export default class FormatError extends Error {
    constructor(message: string) {
        super(message);

        this.name = 'FormatError';
    }
}